import { createFileRoute } from '@tanstack/react-router';
import { fallback, zodValidator } from '@tanstack/zod-adapter';
import { ArchivedShipments } from '@uturn/portal/modules/shipments';
import {
	SHIPMENTS_SEARCH_DEFAULT_STATUSES_ARCHIVED,
	ShipmentsSearchSchema,
	ShipmentsSearchStatusesSchema,
} from '@uturn/portal/router/schema/shipments-search';

const ArchivedShipmentsSearchSchema = ShipmentsSearchSchema.extend({
	'filter.statuses': fallback(
		ShipmentsSearchStatusesSchema.array(),
		SHIPMENTS_SEARCH_DEFAULT_STATUSES_ARCHIVED,
	).default(SHIPMENTS_SEARCH_DEFAULT_STATUSES_ARCHIVED),
});

export const Route = createFileRoute(
	'/_protected/shipments/(overview)/archived',
)({
	component: ArchivedShipments,
	validateSearch: zodValidator(ArchivedShipmentsSearchSchema),
});
